import estimationService from "../../services/estimationService";
import leadService from "../../services/leadService";
import helpers from "@/helpers/helpers"

const getDefaultState = () => {
  return {
    hasSmartMeter: false,
    hasQuarterRegime: false,
    knowPeakLevel: false,
    peakLevel: null,
    valid: false,
    hasSolarPanels: false,
    solarPanelsPower: null,
    solarPanelsCertification: true,
    solarPanelsNumber: null,
    solarPanelsScenario: null,
    doubleFlow: false,
    meterType: [],
    emptyHouse: false,
    knowConsumption: true,
    knowNetConsumption: false,
    consumptions: [
      {
        meterType: "day",
        value: null
      },
      {
        meterType: "night",
        value: null
      },
      {
        meterType: "mono",
        value: null
      },
      {
        meterType: "exclusiveNight",
        value: null
      },
      {
        meterType: "injectionBase",
        value: null
      },
      {
        meterType: "injectionDay",
        value: null
      },
      {
        meterType: "injectionNight",
        value: null
      },
      {
        meterType: "gas",
        value: null
      }
    ],
    occupation: "evening_weekend",
    houseSize: 100,
    people: 2,
    heating: null,
    water: null,
    dishwasher: false,
    dryer: false,
    washingMachine: false,
    electricCar: false,
    battery: false
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setHasSmartMeter(state, value) {
      state.hasSmartMeter = value;
    },
    setHasQuarterRegime(state, value) {
      state.hasQuarterRegime = value;
    },
    setKnowPeakLevel(state, value) {
      state.knowPeakLevel = value;
    },
    setPeakLevel(state, value) {
      state.peakLevel = value;
    },
    setValid(state, value) {
      state.valid = value;
    },
    setMeterType(state, value) {
      state.meterType = value;
    },
    setHasSolarPanels(state, value) {
      state.hasSolarPanels = value;
    },
    setSolarPanelsPower(state, value) {
      state.solarPanelsPower = value;
    },
    setSolarPanelsCertification(state, value) {
      state.solarPanelsCertification = value;
    },
    setSolarPanelsNumber(state, value) {
      state.solarPanelsNumber = value;
    },
    setSolarPanelsScenario(state, value) {
      state.solarPanelsScenario = value;
    },
    setDoubleFlow(state, value) {
      state.doubleFlow = value;
    },
    setEmptyHouse(state, value) {
      state.emptyHouse = value;
    },
    setKnowConsumption(state, value) {
      state.knowConsumption = value;
    },
    setKnowNetConsumption(state, value) {
      state.knowNetConsumption = value;
    },
    setConsumptions(state, value) {
      state.consumptions = value;
    },
    setPeople(state, value) {
      state.people = value < 7 ? value : 7;
    },
    increasePeople(state) {
      if (state.people < 7) state.people += 1;
    },
    decreasePeople(state) {
      if (state.people > 1) state.people -= 1;
    },
    increaseHouseSize(state) {
      if (state.houseSize < 250) {
        state.houseSize =
          state.houseSize < 100 ? state.houseSize + 25 : state.houseSize + 50;
      } else {
        state.houseSize = 250;
      }
    },
    setHouseSize(state, value) {
      if (state.houseSize >= 25 && state.houseSize <= 250) {
        state.houseSize = value;
      } else {
        state.houseSize = 100;
      }
    },
    decreaseHouseSize(state) {
      if (state.houseSize > 25) {
        state.houseSize =
          state.houseSize > 100 ? state.houseSize - 50 : state.houseSize - 25;
      } else {
        state.houseSize = 25;
      }
    },
    setHeating(state, value) {
      state.heating = value;
    },
    setWater(state, value) {
      state.water = value;
    },
    setDishwasher(state, value) {
      state.dishwasher = value;
    },
    setDryer(state, value) {
      state.dryer = value;
    },
    setBattery(state, value) {
      state.battery = value;
    },
    setElectricCar(state, value) {
      state.electricCar = value;
    },
    setWashingMachine(state, value) {
      state.washingMachine = value;
    },
    setOccupation(state, value) {
      state.occupation = value;
    },
    setToDefault(state, value) {
      state.occupation = "evening_weekend";
      state.houseSize = 100;
      state.people = 2;
      state.heating = null;
      state.water = null;
      state.dishwasher = false;
      state.dryer = false;
      state.washingMachine = false;
      state.electricCar = false;
      state.battery = false;
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    async getConsumption(context) {
      let estimationData = await context.dispatch("getEstimationData");

      if (!context.state.knowConsumption) {
        try {
          let response = await estimationService.getEstimation(estimationData);

          let consumptions = [
            {
              meterType: "day",
              value: null
            },
            {
              meterType: "night",
              value: null
            },
            {
              meterType: "mono",
              value: null
            },
            {
              meterType: "injectionBase",
              value: null
            },
            {
              meterType: "injectionNight",
              value: null
            },
            {
              meterType: "injectionDay",
              value: null
            },
            {
              meterType: "exclusiveNight",
              value: null
            },
            {
              meterType: "gas",
              value: null
            }
          ];

          if (response.electricity) {
            Object.keys(response.electricity).forEach(key => {
              let consumptionIndex = consumptions.indexOf(
                consumptions.find(consumption => consumption.meterType === key)
              );

              if (consumptionIndex >= 0)
                consumptions[consumptionIndex] = {
                  meterType: key,
                  value:
                    response.electricity[key] > 0
                      ? response.electricity[key]
                      : 1
                };
            });
          }

          if (response.gas) {
            let consumptionIndex = consumptions.indexOf(
              consumptions.find(consumption => consumption.meterType === "gas")
            );

            if (consumptionIndex >= 0)
              consumptions[consumptionIndex] = {
                meterType: "gas",
                value: response.gas.total > 0 ? response.gas.total : 1
              };
          }
          context.commit("setConsumptions", consumptions);
        } catch (error) {
          throw error;
        }
      }
    },
    getEstimationData(context) {
      let energies = [];
      let hasElec = context.rootGetters["energy/hasElec"];

      if (hasElec) energies.push("electricity");
      if (context.rootGetters["energy/hasGas"]) energies.push("gas");

      let pricingOption = null;
      let exclusiveNight = false;

      if (hasElec) {
        pricingOption = context.state.meterType.includes("night")
          ? "HPHC"
          : "BASE";

        exclusiveNight = context.state.meterType.includes("exclusiveNight");
      }

      let mappingHouseSizing = {
        25: "between_0_and_25",
        50: "between_26_and_50",
        75: "between_51_and_75",
        100: "between_76_and_100",
        150: "between_101_and_150",
        200: "between_151_and_200",
        250: "more_200"
      };

      let houseSize = mappingHouseSizing[context.state.houseSize];

      return {
        energies: energies,
        emptyHouse: context.state.emptyHouse,
        pricingOption: pricingOption,
        exclusiveNight: exclusiveNight,
        people: context.state.people,
        houseSize: houseSize,
        occupation: context.state.occupation,
        heating: context.state.heating,
        water: context.state.water,
        dishwasher: context.state.dishwasher,
        dryer: context.state.dryer,
        washingMachine: context.state.washingMachine,
        solarPanelsPower: context.state.hasSolarPanels
          ? context.state.solarPanelsPower
          : 0,
        solarPanelsScenario: context.state.solarPanelsScenario,
        electricCar: context.state.electricCar,
        battery: context.state.battery
      };
    },
    async save(context) {
      let knowConsumption = context.state.knowConsumption;
      let hasSolarPanels = context.state.hasSolarPanels;
      let data = {
        uuid: context.rootState.common.uuid,
        pricingOption: context.state.meterType.includes("mono")
          ? "BASE"
          : "HPHC",
        solarPanelsPower: hasSolarPanels ? context.state.solarPanelsPower : null,
        solarPanelsNumber: hasSolarPanels ? context.state.solarPanelsNumber : null,
        solarPanelsCertification: hasSolarPanels ? context.state.solarPanelsCertification : null,
        doubleFlow: context.state.doubleFlow,
        emptyHouse: context.state.emptyHouse,
        knowConsumption: context.state.knowConsumption,
        knowNetConsumption: context.state.knowNetConsumption,
        people: !knowConsumption ? context.state.people : null,
        houseSize: !knowConsumption ? context.state.houseSize : null,
        occupation: !knowConsumption ? context.state.occupation : null,
        heating: !knowConsumption ? context.state.heating : null,
        water: !knowConsumption ? context.state.water : null,
        dryer: !knowConsumption ? context.state.dryer : null,
        washingMachine: !knowConsumption ? context.state.washingMachine : null,
        dishwasher: !knowConsumption ? context.state.dishwasher : null,
        electricCar: !knowConsumption ? context.state.electricCar : null,
        battery: !knowConsumption ? context.state.battery : null,
        hasSmartMeter: context.state.hasSmartMeter,
        hasQuarterRegime: context.state.hasQuarterRegime,
        knowPeakLevel: context.state.knowPeakLevel,
        peakLevel: context.state.peakLevel,
        consumptionElecBase: null,
        consumptionElecHigh: null,
        consumptionElecLow: null,
        consumptionElecNight: null,
        injectionElecBase: null,
        injectionElecHigh: null,
        injectionElecLow: null,
        consumptionGas: null
      };

      context.getters["activeConsumptions"].forEach(consumption => {
        switch (consumption.meterType) {
          case "mono":
            data["consumptionElecBase"] = consumption.value;
            break;
          case "day":
            data["consumptionElecHigh"] = consumption.value;
            break;
          case "night":
            data["consumptionElecLow"] = consumption.value;
            break;
          case "exclusiveNight":
            data["consumptionElecNight"] = consumption.value;
            break;
          case "gas":
            data["consumptionGas"] = consumption.value;
            break;
          case "injectionBase":
            data["injectionElecBase"] = consumption.value;
            break;
          case "injectionDay":
            data["injectionElecHigh"] = consumption.value;
            break;
          case "injectionNight":
            data["injectionElecLow"] = consumption.value;
            break;
        }
      });

      try {
        await leadService.save(data);
      } catch (error) {
        throw error;
      }
    },
    recomputeActiveConsumptionValues(context, add) {
      context.state.consumptions = context.state.consumptions.map(function (consumption) {
          if (consumption.value && context.state.meterType.includes(consumption.meterType) && !consumption.meterType.includes('gas')) {
            if (consumption.meterType.includes('injection')) {
              let newValue = add ? parseInt(consumption.value) / 0.7 : parseInt(consumption.value) * 0.7;
              return {
                meterType: consumption.meterType,
                value: Math.round(newValue)
              }
            } else {
              let injection = null;
              if (consumption.meterType === 'mono') {
                injection = context.state.consumptions.find(obj => {
                  return obj.meterType === 'injectionBase'
                })
              }
              if (consumption.meterType === 'day') {
                injection = context.state.consumptions.find(obj => {
                  return obj.meterType === 'injectionDay'
                })
              }
              if (consumption.meterType === 'night') {
                injection = context.state.consumptions.find(obj => {
                  return obj.meterType === 'injectionNight'
                });
              }

              let newValue = Math.round(
                add ?
                  parseInt(consumption.value) + ((injection && injection.value ? (parseInt(injection.value) / 0.7) : 0) * 0.3) :
                  parseInt(consumption.value) - ((injection && injection.value ? parseInt(injection.value) : 0) * 0.3)
              );

              if(newValue < 0) {
                newValue = 0
              }

              return {
                meterType: consumption.meterType,
                value: newValue
              }
            }
          }
          return consumption
        }
      )
    },
    computePeakLevel(context) {
      const basePeakLevel = 2.5;
      const consumptions = context.getters["activeConsumptions"];
      const monoIndex = consumptions.findIndex(consumption => consumption.meterType === 'mono');
      const dayIndex = consumptions.findIndex(consumption => consumption.meterType === 'day');
      const nightIndex = consumptions.findIndex(consumption => consumption.meterType === 'night');
      const exclNightIndex = consumptions.findIndex(consumption => consumption.meterType === 'exclusiveNight');
      const injectionBaseIndex = consumptions.findIndex(consumption => consumption.meterType === 'injectionBase');
      const injectionDayIndex = consumptions.findIndex(consumption => consumption.meterType === 'injectionDay');
      const injectionNightIndex = consumptions.findIndex(consumption => consumption.meterType === 'injectionNight');

      const consumption = monoIndex > -1 ? parseFloat(consumptions[monoIndex].value) : parseFloat(consumptions[dayIndex].value) + parseFloat(consumptions[nightIndex].value);
      const injection = injectionBaseIndex > -1 ? parseFloat(consumptions[injectionBaseIndex].value) : (injectionDayIndex > -1 && injectionNightIndex > -1 ? parseFloat(consumptions[injectionDayIndex].value) + parseFloat(consumptions[injectionNightIndex].value) : null);
      const exclusiveNight = exclNightIndex > -1 ? parseFloat(consumptions[exclNightIndex].value) : null;
      const solarPanelPower = context.state.hasSolarPanels ? parseFloat(context.state.solarPanelsPower) : null;

      const peakLevel = Math.max(basePeakLevel, computeFormula(consumption, injection, exclusiveNight, solarPanelPower));
      context.commit('setPeakLevel', peakLevel.toString());
    },
  },
  getters: {
    elecMeterTypes: state => {
      let meterTypes = [...state.meterType];

      let index = meterTypes.indexOf("mono");
      if (index >= 0) meterTypes[index] = "day";

      meterTypes = meterTypes.filter(meterType => meterType !== "gas" && !meterType.includes('injection'));

      return meterTypes;
    },
    activeConsumptions: state => {
      let res =  state.consumptions.filter(consumption =>
        state.meterType.includes(consumption.meterType)
      );
      return helpers.unique(res, 'meterType');
    },
    monoMeter: (_, context) => context.activeConsumptions.find(item => item.meterType == "mono"),
    gasMeter: (_, context) => context.activeConsumptions.find(item => item.meterType == "gas"),
    nightMeter: (_, context) => context.activeConsumptions.find(item => item.meterType == "exclusiveNight"),
    injectionBaseMeter: (_, context) => context.activeConsumptions.find(item => item.meterType == "injectionBase"),
    injectionTouMeter: (_, context) => {
      const mapped = context.activeConsumptions.reduce((prev, curr) => {
        if (["injectionDay", "injectionNight"].includes(curr.meterType)) {
            prev[curr.meterType] = curr.value;
        }
        return prev;
      }, {})

      if (Object.keys(mapped).length === 0) {
        return false;
      }

      return mapped;
    },
    touMeter: (_, context) => {
      const mapped = context.activeConsumptions.reduce((prev, curr) => {
        if (["day", "night"].includes(curr.meterType)) {
            prev[curr.meterType] = curr.value;
        }
        return prev;
      }, {})

      if (Object.keys(mapped).length === 0) {
        return false;
      }

      return mapped;
    },
  }
};

const computeFormula = (consumption, injection = null, exclusiveNightConsumption = null, solarPanelPower = null) => {
  const totalConsumption = consumption + (injection ? getAutoConsumption(injection) : 0);
  const exclNightFormulaPart = exclusiveNightConsumption ? 0.0007876 * exclusiveNightConsumption : 0;
  const solarPanelFormulaPart = solarPanelPower ? 0.02464 * getMaxSolarPanelPower(solarPanelPower) : 0;
  return 2.73 * Math.log((totalConsumption / 931) + 1) + exclNightFormulaPart - solarPanelFormulaPart;
};

const getAutoConsumption = (injection) => {
  return (injection / 0.64) - injection;
};

const getMaxSolarPanelPower = (solarPanelPower) => {
  return solarPanelPower * 10 / 9;
}



// WEBPACK FOOTER //
// ./src/store/modules/consumption.js